module.exports = __webpack_public_path__ + "static/img/maintenance-2.b8f8c47f.png";